 
import React, { useContext, useEffect, useState, useMemo, useRef } from "react";

import { Link, useLocation, useSearchParams, useParams, useNavigate,Outlet } from 'react-router-dom';

 

import http from "../Services/httpService";
import noronServices from "../Services/noronServices";

export default function LayoutPublic() {
let navigate = useNavigate();
    useEffect(() => {
        const jwt = http.getLocalJwt();
        if (jwt && jwt != "") {
            navigate('/main', { replace: true })
        }

    }, []);


    return (

        <>
            <Outlet />

        </>


    );
}
